export default {
  inject: ['i18n'],

  methods: {
    _(key) {
      return (this.i18n || {})[key] || key;
    }
  }
};
